var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockCountDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ClockCountdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.75 11.6875C19.4002 15.9225 15.8252 19.25 11.5 19.25C9.31196 19.25 7.21354 18.3808 5.66637 16.8336C4.11919 15.2865 3.25 13.188 3.25 11C3.25 6.67477 6.5775 3.09977 10.8125 2.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5 6.1875V11H16.3125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.25 3.95312C14.7246 3.95312 15.1094 3.56837 15.1094 3.09375C15.1094 2.61913 14.7246 2.23438 14.25 2.23438C13.7754 2.23438 13.3906 2.61913 13.3906 3.09375C13.3906 3.56837 13.7754 3.95312 14.25 3.95312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.3438 6.01562C17.8184 6.01562 18.2031 5.63087 18.2031 5.15625C18.2031 4.68163 17.8184 4.29688 17.3438 4.29688C16.8691 4.29688 16.4844 4.68163 16.4844 5.15625C16.4844 5.63087 16.8691 6.01562 17.3438 6.01562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.4062 9.10938C19.8809 9.10938 20.2656 8.72462 20.2656 8.25C20.2656 7.77538 19.8809 7.39062 19.4062 7.39062C18.9316 7.39062 18.5469 7.77538 18.5469 8.25C18.5469 8.72462 18.9316 9.10938 19.4062 9.10938Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCountDown);
export default __webpack_public_path__ + "static/media/clock_count_down.2feb586cbec2a0159d5a2d0681f4add1.svg";
export { ForwardRef as ReactComponent };